import { MessageBar, MessageBarType, Spinner, SpinnerSize, Stack } from '@fluentui/react';

interface ConnectionStatusProps {
  isAutoConnecting: boolean;
  autoConnectionError: string | null;
  activeWorkspaceInitialized: boolean;
}

export const ConnectionStatus = (props: ConnectionStatusProps) => {
  const { isAutoConnecting, autoConnectionError, activeWorkspaceInitialized } = props;

  if (!activeWorkspaceInitialized) {
    return (
      <Stack horizontalAlign="center" tokens={{ childrenGap: 16 }}>
        <Spinner size={SpinnerSize.large} label="Initializing workspace..." />
        <p>Waiting for workspace to be ready...</p>
      </Stack>
    );
  }

  if (isAutoConnecting) {
    return (
      <Stack horizontalAlign="center" tokens={{ childrenGap: 16 }}>
        <Spinner size={SpinnerSize.large} label="Connecting to H2O Drive..." />
        <p>Establishing connection to your workspace storage...</p>
      </Stack>
    );
  }

  if (autoConnectionError) {
    return (
      <Stack tokens={{ childrenGap: 16 }}>
        <MessageBar messageBarType={MessageBarType.error}>
          <strong>Connection Failed:</strong> {autoConnectionError}
        </MessageBar>
        <button onClick={() => window.location.reload()} style={{ padding: '8px 16px', fontSize: '14px' }}>
          Retry Connection
        </button>
      </Stack>
    );
  }

  return null;
};
